<template>
  <div class='CategoryList'>
    <div class="img" @click="push">
      <img v-if="data.img.length" :src="api + data.img">
      <div v-if="!data.img.length" class="icon-img">
        <img-icon :options="{ width: '55px', height: '45px', color: '#CCCCCC', action: true }"/>
      </div>
    </div>
    <div class="text">{{ data.nome }}</div>
    <div class="btn">
      <button @click="push">CONHECER</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ImgIcon from '../EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'CategoryList',
  components: { ImgIcon },
  props: ['data'],
  mixins: [api],
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    ...mapActions(['changeFilterProdStore', 'GetStoreProducts']),
    push () {
      this.changeFilterProdStore({ categoria: this.data.link })
        .then(() => {
          this.GetStoreProducts({ params: { last: [], limit: 8, categoria: this.data.link }, init: true })
            .then(() => {
                this.$router.push(this.Empresa.modelo === 'Modelo 03' ? `/site/${this.data.link}` : `/loja/${this.data.link}`)
              })
        })
    },
    substituirEspacosPorHifen (str) {
      return str.replace(/\s+/g, '-');
    }
  }
}
</script>

<style scoped>
.CategoryList {
  width: 180px;
  height: 300px;
  margin: 1%;
  background-color: #FFFFFF;
  border-radius: 7px;
  overflow: hidden;
}

.img {
  width: 100%;
  height: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 100%;
  height: 100%;
  opacity: 0.70;
  animation: startOff 0.5s forwards;
  cursor: pointer;
}

img:hover {
  opacity: 1;
  animation: startOn 0.5s forwards;
}

.icon-img {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 20px;
}

.btn {
  width: 100%;
  height: 17%;
  display: flex;
  justify-content: center;
  align-items: center;
}

button {
  border: 0;
  color: #FFFFFF;
  padding: 4%;
  background-color: #000000;
  border-radius: 8px;
  cursor: pointer;
  animation: startOffBtn 0.5s forwards;
}

button:hover {
  animation: startOnBtn 0.5s forwards;
}

@keyframes startOn {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.70;
  }
}
@keyframes startOff {
  0% {
    opacity: 0.70;
  }
  100% {
    opacity: 1;
  }
}
@keyframes startOnBtn {
  0% {
    color: #FFFFFF;
    background-color: #000000;
  }
  100% {
    color: #000000;
    background-color: #CCCCCC;
  }
}
@keyframes startOffBtn {
  0% {
    color: #000000;
    background-color: #CCCCCC;
  }
  100% {
    color: #FFFFFF;
    background-color: #000000;
  }
}

@media (max-width: 500px) {
  .CategoryList {
    width: 180px;
    height: 310px;
    margin: 2%;
  }

  .img {
    height: 200px;
  }

  .text {
    width: 90%;
    padding: 5%;
  }

  .btn {
    width: 100%;
  }
}
</style>
